module.exports = __webpack_public_path__ + "static/media/winnerIs.324b9792.mp3";